var FIGURE = FIGURE || {};

// Pins the page behind an open bootstrap modal (WEB-478). Bootstrap's `body.modal-open
// { overflow: hidden }` doesn't stop touch scrolling on iOS Safari, so the page moved under the
// age gate. Fixing <body> at the current offset does, and the offset is restored on the way out.
FIGURE.modalScrollLock = function () {
    if (!window.jQuery) return;

    var body = document.body;
    var locked = false;
    var lockedY = 0;

    function lock() {
        if (locked) return;
        locked = true;
        lockedY = window.scrollY || window.pageYOffset || 0;
        body.style.position = 'fixed';
        body.style.top = -lockedY + 'px';
        body.style.left = '0';
        body.style.right = '0';
    }

    function unlock() {
        if (!locked) return;
        locked = false;
        ['position', 'top', 'left', 'right'].forEach(function (prop) {
            body.style.removeProperty(prop);
        });
        window.scrollTo(0, lockedY);
    }

    window.jQuery(document)
        .on('show.bs.modal', '.modal', function (e) {
            if (!e.isDefaultPrevented()) lock();
        })
        // Released at the start of the hide, while body.modal-open still freezes the header, so the
        // restored offset isn't read as a scroll. Held while a stacked modal is still showing.
        .on('hide.bs.modal', '.modal', function (e) {
            if (e.isDefaultPrevented()) return;
            if (window.jQuery('.modal.show').not(this).length === 0) unlock();
        });
}();
